import { map, path,join } from "ramda";
import { normalizePath, normalizePathDot } from "./normalize";


export type SelectorFunction<T> = (key: string, value: any) => T;
export type Kvp<T = string, V = string> = { key: T; value: V };

export const mapToPairs = <T>(
  paths: any[],
  target: object,
  selector: SelectorFunction<T> = (key, value) => ({ key, value })  as T
):T[] => {
  const normalizedPaths = map(normalizePath, paths);
  const result = map((pathArray: string[]) => {
    const key = join(".",pathArray);
    const value = path(pathArray, target);
    return selector(key, value);
  }, normalizedPaths);
  return result;
};
